export default function CallButton() {
    return (
        <div className="call-btn">
            <a href="tel: +381648738755"><div className="contact-btn"><p className="btn-text"></p>Pozovite nas</div></a>
        </div>
    );
}